import { render, staticRenderFns } from "./CategoryShow.vue?vue&type=template&id=567dd2cd&"
import script from "./CategoryShow.vue?vue&type=script&lang=js&"
export * from "./CategoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports